'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Creatable = require('react-select/lib/Creatable');

var _Creatable2 = _interopRequireDefault(_Creatable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimeListItem = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(TimeListItem, _Component);

  function TimeListItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TimeListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimeListItem.__proto__ || (0, _getPrototypeOf2.default)(TimeListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hasError: false,
      endTime: null,
      startTime: null
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TimeListItem, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateTimeState(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.updateTimeState(nextProps);
    }
  }, {
    key: 'getHours',
    value: function getHours() {
      var hours = [];

      for (var hour = 0; hour <= 24; hour++) {
        for (var minute = 0; minute < 60; minute += 15) {
          if (hour === 24 && minute > 0) {
            break;
          }

          var newValue = window.Kalendae.moment(this.props.selectedDate).set({ hour: hour, minute: minute });
          var label = newValue.format('HH:mm');
          hours.push({ date: newValue, value: label, label: label });
        }
      }

      return hours;
    }
  }, {
    key: 'createStartTime',
    value: function createStartTime(search) {
      var _this2 = this;

      var input = search.split(':');
      var hour = input[0];
      var minute = input[1];
      var newValue = window.Kalendae.moment(this.props.selectedDate).set({ hour: hour, minute: minute });
      var startTime = {
        label: search,
        value: search,
        date: newValue
      };

      this.setState({
        startTime: startTime
      }, function () {
        _this2.updateTime(startTime || '', 'start_time');
      });
    }
  }, {
    key: 'createEndTime',
    value: function createEndTime(search) {
      var _this3 = this;

      var input = search.split(':');
      var hour = input[0];
      var minute = input[1];
      // convert string into a time object
      var newValue = window.Kalendae.moment(this.props.selectedDate).set({ hour: hour, minute: minute });
      var endTime = {
        label: search,
        value: search,
        date: newValue
      };

      this.setState({
        endTime: endTime
      }, function () {
        _this3.updateTime(endTime || '', 'end_time');
      });
    }
  }, {
    key: 'updateTimeState',
    value: function updateTimeState(props) {
      var startDate = props.item.start_date ? window.Kalendae.moment(props.item.start_date) : null;
      var endDate = startDate && props.item.duration ? window.Kalendae.moment(startDate).add(props.item.duration, 'seconds') : null;

      this.setState({
        startTime: startDate ? {
          date: startDate,
          label: startDate.format('HH:mm'),
          value: startDate.format('HH:mm')
        } : null,
        endTime: endDate ? {
          date: endDate,
          label: endDate.format('HH:mm'),
          value: endDate.format('HH:mm')
        } : null,
        hasError: !!props.item.error
      });
    }
  }, {
    key: 'updateStartTime',
    value: function updateStartTime(time, _ref2) {
      var _this4 = this;

      var action = _ref2.action;

      var startTime = time ? (0, _extends3.default)({}, time) : null;

      if (startTime && action === 'create-option') {
        // convert the hour (HH:mm) into a date object
        startTime.date = window.Kalendae.moment(this.props.selectedDate).set(startTime.label);

        var hours = this.getHours();
        hours.push({ date: startTime.value, value: startTime.label, label: startTime.label });
      }

      if (!startTime) {

        this.setState({
          startTime: startTime,
          endTime: null
        }, function () {
          _this4.updateTime(null, 'end_time');
          _this4.updateTime(startTime, 'start_time');
        });
      } else {
        this.setState({
          startTime: startTime
        }, function () {
          _this4.updateTime(startTime, 'start_time');
        });
      }
    }
  }, {
    key: 'updateEndTime',
    value: function updateEndTime(time) {
      var _this5 = this;

      this.setState({
        endTime: time
      }, function () {
        _this5.updateTime(time, 'end_time');
      });
    }
  }, {
    key: 'updateTime',
    value: function updateTime(time, field) {
      var duration = void 0;

      if (!time) {
        duration = null;
      } else if (field === 'start_time' && this.state.endTime) {
        duration = time.date.diff(this.state.endTime.date, 'seconds');
      } else if (field === 'end_time' && this.state.startTime) {
        duration = this.state.startTime.date.diff(time.date, 'seconds');
      }
      if (this.state.startTime) {
        duration = isNaN(duration) ? null : Math.abs(duration);
        this.props.updateTime(this.state.startTime.date, duration, this.props.index, this.props.selectedDate.format('YYYY-MM-DD'));
      }
    }
  }, {
    key: 'removeTime',
    value: function removeTime() {
      return this.props.removeTime(this.props.selectedDate, this.props.index);
    }
  }, {
    key: 'filterEndTimeOptions',
    value: function filterEndTimeOptions(_ref3, input) {
      var data = _ref3.data;

      if (!this.state.startTime) {
        return false;
      }

      if (data.__isNew__) {
        return true;
      }

      if (data.date.diff(this.state.startTime.date, 'hours', true) <= 0) {
        return false;
      }

      return !!data.label.match(input);
    }
  }, {
    key: 'isValidNewOptionForEndTime',
    value: function isValidNewOptionForEndTime(input, _, selectOptions) {
      if (!input.match(/^[0-9]{1,2}:[0-9]{2}$/)) {
        return false;
      }

      if (!this.state.startTime) {
        return false;
      }

      if (selectOptions.find(function (o) {
        return o.label === input || o.label === '0' + input;
      })) {
        return false;
      }

      var endDate = window.Kalendae.moment(this.props.selectedDate.format('YYYY-MM-DD') + ' ' + input + ':00');
      return endDate.diff(this.state.startTime.date, 'hours', true) > 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var hours = this.getHours();
      var _state = this.state,
          hasError = _state.hasError,
          endTime = _state.endTime,
          startTime = _state.startTime;
      var _props = this.props,
          multipleTimes = _props.multipleTimes,
          multipleDates = _props.multipleDates,
          addTimeRow = _props.addTimeRow,
          selectedDate = _props.selectedDate,
          last = _props.last,
          index = _props.index,
          applyToAllDates = _props.applyToAllDates,
          polyglot = _props.polyglot;


      return _react2.default.createElement(
        'div',
        { className: 'times-list-item-hours' },
        polyglot.t('events.form.calendar.time.from'),
        _react2.default.createElement(
          'div',
          { className: 'times-list-item-select' },
          _react2.default.createElement(_Creatable2.default, {
            className: 'react-select' + (hasError ? ' has-error' : ''),
            classNamePrefix: 'react-select',
            ref: 'startTime',
            name: 'startTime',
            options: hours,
            value: startTime,
            placeholder: polyglot.t('events.form.calendar.time.startTime'),
            onChange: this.updateStartTime.bind(this),
            onCreateOption: this.createStartTime.bind(this),
            noOptionsMessage: function noOptionsMessage() {
              return polyglot.t('events.form.calendar.time.invalidFormat');
            },
            formatCreateLabel: function formatCreateLabel(label) {
              return label;
            },
            isValidNewOption: function isValidNewOption(inputValue) {
              return inputValue.match(/^[0-9]{1,2}:[0-9]{2}$/);
            },
            isClearable: true,
            tabSelectsValue: true })
        ),
        polyglot.t('events.form.calendar.time.to'),
        _react2.default.createElement(
          'div',
          { className: 'times-list-item-select' },
          _react2.default.createElement(_Creatable2.default, {
            className: 'react-select',
            classNamePrefix: 'react-select',
            ref: 'endTime',
            options: hours,
            filterOption: this.filterEndTimeOptions.bind(this),
            formatCreateLabel: function formatCreateLabel(label) {
              return label;
            },
            isClearable: true,
            isValidNewOption: this.isValidNewOptionForEndTime.bind(this),
            value: endTime,
            noOptionsMessage: function noOptionsMessage() {
              if (_this6.state.startTime) {
                return polyglot.t('events.form.calendar.time.invalidEndTime');
              }

              return polyglot.t('events.form.calendar.time.fillStartTime');
            },
            placeholder: polyglot.t('events.form.calendar.time.endTime'),
            onChange: this.updateEndTime.bind(this),
            onCreateOption: this.createEndTime.bind(this),
            tabSelectsValue: true })
        ),
        this.state.startTime && _react2.default.createElement('a', { className: 'result-delete', onClick: this.removeTime.bind(this) }),
        multipleTimes && last && _react2.default.createElement('span', { onClick: addTimeRow.bind(null, selectedDate), className: 'icon-cg-add' }),
        multipleDates && this.state.startTime && !index && _react2.default.createElement(
          'a',
          { href: '#', onClick: applyToAllDates.bind(null, selectedDate), className: 'link apply-to-all-link' },
          polyglot.t('events.form.calendar.applyToAllDates')
        )
      );
    }
  }]);
  return TimeListItem;
}(_react.Component), _class.propTypes = {
  item: _propTypes2.default.object,
  index: _propTypes2.default.number,
  removeTime: _propTypes2.default.func,
  selectedDate: _propTypes2.default.object,
  updateTime: _propTypes2.default.func,
  multipleTimes: _propTypes2.default.bool,
  multipleDates: _propTypes2.default.bool,
  addTimeRow: _propTypes2.default.func,
  applyToAllDates: _propTypes2.default.func,
  last: _propTypes2.default.bool,
  polyglot: _propTypes2.default.object.isRequired
}, _temp2);
exports.default = TimeListItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/DatesBox/TimeListItem.js
// module id = 2209
// module chunks = 0